import t from '@instructure/quiz-i18n/es/format-message';
export var noneOf = function noneOf(val, options) {
  var blacklist = options.blacklist;
  var message = options.message || t('value is not permitted');
  if (blacklist.includes(val)) {
    return message;
  }
};
export default noneOf;